export default "__VITE_ASSET__146044ff__"